import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { managementFinanceAPI } from "../../../../api/managementFinanceAPI";
import SupplierOutstanding from '../../../../assets/images/SupplierOutstanding.png';
import SupplierOutstandingChart from '../../../chart/managementFinanceChart/SupplierOutstandingChart/SupplierOutstandingChart';
import AllPcode from "../../../allPcode";
import usePcode from "../../../../common/hooks/usePcode";


export default function SupplierOutstandingModal() {

    const [isFetching, setIsFetching] = useState(false);
    const [showChart, setShowChart] = useState(false);
    const [data, setData] = useState([]);
    const { loggedPcode } = usePcode();
    const [selectedPcode, setSelectedPcode] = useState(loggedPcode);


    const handleData = (selectedPcode) => {
        setIsFetching(true)
        managementFinanceAPI.getSupplierOutstanding(selectedPcode).then((data) => {
            setData(data);
            setIsFetching(false);
        }).catch((e) => {
            setIsFetching(false);
            toast.warn(e.message);
        })
    }

    const chartData = [['Days Range', 'Outstanding Amount']];
    data.forEach(item => {
        chartData.push([item.dayRange, parseFloat(item.outstandingAmount)])
    });

    useEffect(() => {
        handleData(selectedPcode);
    }, [selectedPcode])

    useEffect(() => {
        const handleShowChart = () => {
            setShowChart(true);
        };

        const modalElement = document.getElementById("SupplierOutstanding");
        if (modalElement) {
            modalElement.addEventListener("shown.bs.modal", handleShowChart);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("shown.bs.modal", handleShowChart);
            }
        };
    }, []);

    return (
        <>
            <a type="button" className='border border-0 rounded rounded-5' data-bs-toggle="modal" data-bs-target="#SupplierOutstanding">
                <img src={SupplierOutstanding} class="card-img-top rounded rounded-5" alt="SupplierOutstanding" />
            </a>
            <div className="modal fade" id="SupplierOutstanding" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Supplier Outstanding</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body w-100 h-100 bg-light">
                            <div className="row">
                                <div className="col-0 col-sm-0 col-md-0 col-lg-9 col-xl-9 col-xxl-9">
                                    <div className="input-group input-group-sm">
                                        <AllPcode setSelectedPcode={setSelectedPcode} loggedPcode={loggedPcode} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                                </div>
                                <SupplierOutstandingChart data={chartData} loading={isFetching} showChart={showChart} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}